import React from 'react'
import PropTypes from 'prop-types'

import PlayerImg from '@shared/components/playerImg'
import CommentaryCommonBox from '@shared/components/match/commentaryCommonBox'

export default function TrendingPlayer({ player, onSelectPlayer }) {
  const playerPicStyle = { width: '26px' }
  const nameStyle = { textOverflow: 'ellipsis' }
  const iconStyle = { transform: 'rotate(45deg)' }
  const border = { border: '1px solid var(--border-light)', borderRadius: '30px' }

  return (
    <CommentaryCommonBox title="Compare Currently Trending Players" isWrapParagraph={false} contentClass="d-flex flex-wrap gap-2">
      {player?.map((ele, index) => (
        <div
          key={ele?._id}
          className="text-nowrap d-flex align-items-center p-1 gap-2 c-pointer"
          style={border}
          onClick={() => onSelectPlayer(ele)}
        >
          <span style={playerPicStyle} className="rounded-circle overflow-hidden">
            <PlayerImg head={ele?.oImg} jersey={ele?.oPrimaryTeam?.oJersey} />
          </span>
          <span style={nameStyle} className="text-nowrap overflow-hidden m-0">
            {ele?.sFullName || ele?.sFirstName}
          </span>
          <span style={iconStyle} className="text-primary m-0">
            <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="close-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <polygon
                  fill="currentColor"
                  fillRule="nonzero"
                  points="18.6398758 20 12.504799 13.8592679 6.36977052 20 5 18.6311041 11.1446748 12.5000121 5 6.3688911 6.36977052 5 12.504799 11.1407562 18.6398758 5.00964011 20 6.3688911 13.8649233 12.5000121 20 18.6311041"
                />
              </g>
            </svg>
          </span>
        </div>
      ))}
    </CommentaryCommonBox>
  )
}
TrendingPlayer.propTypes = {
  player: PropTypes.array,
  onSelectPlayer: PropTypes.func
}
